"use client";

import { useEffect } from "react";
import { chatEventListeners } from "@/src/helpers/aiService";
import { useToast } from "@/src/contexts/toastContext";
import { useUsageLimit } from "@/src/contexts/usageLimitContext";

// Bridges WebSocket-triggered events from the AiChat singleton into React
// hooks (toasts and the usage-limit modal). Mount once near the root.
export default function ChatEventBridge() {
  const { push } = useToast();
  const { open: openUsageLimit } = useUsageLimit();

  useEffect(() => {
    chatEventListeners.onUsageLimitExceeded = (data) => {
      openUsageLimit(data);
    };
    chatEventListeners.onContextCompacted = (data) => {
      const turns = data?.summarized_turns ?? 0;
      push({
        title: "Older messages summarized",
        description: turns
          ? `${turns} message${turns === 1 ? "" : "s"} compacted to fit the context window.`
          : "Older turns compacted to fit the context window.",
        kind: "success",
        duration: 4200,
      });
    };
    return () => {
      chatEventListeners.onUsageLimitExceeded = null;
      chatEventListeners.onContextCompacted = null;
    };
  }, [push, openUsageLimit]);

  return null;
}
